if (!customElements.get('age-gate')) {
  class AgeGate extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('hidden')) {
        this.remove();
        return;
      }

      this.storageKey = this.dataset.storageKey || 'age-gate-verified';
      this.declineUrl = this.dataset.declineUrl || '/';
      this.isDesignMode = this.hasAttribute('data-design-mode');

      this.confirmButton = this.querySelector('[data-age-gate-confirm]');
      this.declineButton = this.querySelector('[data-age-gate-decline]');

      this.onConfirm = this.onConfirm.bind(this);
      this.onDecline = this.onDecline.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      document.documentElement.classList.add('age-gate-open');
      this.confirmButton?.focus();

      this.confirmButton?.addEventListener('click', this.onConfirm);
      this.declineButton?.addEventListener('click', this.onDecline);
      document.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      this.confirmButton?.removeEventListener('click', this.onConfirm);
      this.declineButton?.removeEventListener('click', this.onDecline);
      document.removeEventListener('keydown', this.onKeyDown);
      document.documentElement.classList.remove('age-gate-open');
    }

    setVerified() {
      try {
        sessionStorage.setItem(this.storageKey, 'true');
      } catch (error) {}
    }

    close() {
      this.hidden = true;
      document.documentElement.classList.remove('age-gate-open');
      this.remove();
    }

    onConfirm() {
      if (!this.isDesignMode) {
        this.setVerified();
      }
      this.close();
    }

    onDecline() {
      window.location.href = this.declineUrl;
    }

    onKeyDown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    }
  }

  customElements.define('age-gate', AgeGate);
}
